import { ReadonlyRecord } from '@bimser/core';
import { Record, List } from 'immutable';

export interface IBaseEventProperty {
	methodKey: string;
	methodName: string;
}

export interface IEventProperty extends IBaseEventProperty {}

export interface IReadonlyBaseEventProperty extends IBaseEventProperty {}

export type EventProperty = ReadonlyRecord<IReadonlyBaseEventProperty>;

export const EventPropertyFactory = Record<IReadonlyBaseEventProperty>({
	methodKey: null,
	methodName: null
});

export const EventPropertyFactoryFromJS = function (data: IEventProperty) {
	return EventPropertyFactory({
		methodKey: data.methodKey,
		methodName: data.methodName
	});
};
